import React, { useState, useEffect, useContext } from "react";
import { Notifications } from "@mui/icons-material";
import Modal from "react-modal";
import FlatList from "flatlist-react";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";
import { LayoutContext } from "./AdminLayout";

const AdminLate = () => {
  const {fetchData} = useContext(LayoutContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [sickSearchTerm, setSickSearchTerm] = useState("");
  const [family, setFamily] = useState("");
  const [familycode, setFamilycode] = useState("");
  const [contactlist, setContactlist] = useState([]);
  const [deadlist, setDeadlist] = useState([]);

  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isShowDied, setIsShowDied] = useState(false);
  const [hasMember, setHasMember] = useState("");

  const [memberdata, setMemberdata] = React.useState({
    id: "",
    firstName: "",
    lastName: "",
    place: "",
    gender: "",
    burrialplace: "",
    diedon: "",
    info: "",
    img: null,
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const showMembers = async () => {
    setIsShowDied(false);
  }


  const markAlive = async (recordid) => {
  
    const formData = new FormData();
    formData.append("recordid", recordid);
 
    const baseUrl = apilink.link;
    await axios
      .post(`${baseUrl}/family/alive`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      .then((response) => {
        console.log("Message" + response.data.message);

        if (response.data.message == "Saving successfull") {
          setMemberdata({
            id: "",
            firstName: "",
            lastName: "",
            place: "",
            gender: "",
            burrialplace: "",
            diedon: "",
            info: "",
            img: null,
          });
         
        
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          showDead();
          return;
        }
      })
      .catch((error) => {
        
        console.log(error.response.data.message);
      });
  }

  const showDead = async () => {
    const storedUser = await JSON.parse(
      localStorage.getItem("userSessionData")
    );
    
    //Get sick members from API
    setIsSearching(true);
    const baseUrl = apilink.link;
    await axios
      .get(`${baseUrl}/family/members/${storedUser.familycode}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        setIsShowDied(true);
        setIsSearching(false);
        if (response.data.message == "Successfull") {
          console.log(response.data.records.filter((item) => item.healed === "No"))
          setDeadlist(
            response.data.records.filter((item) => item.diedon !== null)
          );
          fetchData();
        }
      })
      .catch((error) => {
        setIsShowDied(true);
        setIsSearching(false);
        console.log(error.response.data.message);
      });
  };

  const handleSubmit = async () => {
    if (memberdata.burrialplace == "") {
      toast.warn("Saving failed. Type in the burrial place first", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const formData = new FormData();
    formData.append("memberid", memberdata.id);
    formData.append("familycode", familycode);
    formData.append("burriedat", memberdata.burrialplace);
    formData.append("dieddon", memberdata.diedon);
   
    const baseUrl = apilink.link;
    await axios
      .post(`${baseUrl}/family/death`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      .then((response) => {
        console.log("Message" + response.data.message);

        if (response.data.message == "Saving successfull") {
          setMemberdata({
            id: "",
            firstName: "",
            lastName: "",
            place: "",
            gender: "",
            burrialplace: "",
            diedon: "",
            info: "",
            img: null,
          });
          setIsImageUploading(false);
          closeModal();
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          showDead(false);
          return;
        }
      })
      .catch((error) => {
        setIsImageUploading(false);
        console.log(error.response.data.message);
      });
  };

  function openModal(id) {
    let result = contactlist.find((obj) => obj.id == id);
    setMemberdata({
      id: result.id,
      firstName: result.alias,
      lastName: result.surname,
      place: result.residance,
      gender: result.gender,
      burrialplace: "",
      diedon: "",
      info: "",
      img: result.img,
    });
    setModalIsOpen(true);
  }

  function closeModal() {
    setMemberdata({
      id: "",
      firstName: "",
      lastName: "",
      place: "",
      gender: "",
      burrialplace: "",
      diedon: "",
      info: "",
      img: null,
    });
    setModalIsOpen(false);
  }

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );
      setFamily(storedUser.family);
      setFamilycode(storedUser.familycode);
      setHasMember(storedUser.hasmember);
      //Get members from API

      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setContactlist(
              response.data.records.filter((item) => item.diedon === null)
            );
          }
        })
        .catch((error) => {
          setIsImageUploading(false);
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);

  const renderPerson = (person, idx) => {
    return (
      <div
        onClick={() => openModal(idx)}
        style={{ flexDirection: "column", marginBottom: "30px" }}
        key={idx}
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <b>
              {person.alias} {person.surname}
            </b>
            <h6 style={{ fontFamily: "Open Sans" }}>
              {person.parent != null && (
                <>{person.gender == "Female" ? "Daughter Of" : "Son Of"} </>
              )}
              {person.parent == null ? "Root Member" : person.parentname}
            </h6>
            {person.parent != null && (
              <>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  Child Number: {person.born}
                </h6>
              </>
            )}
          </div>
          <div>
            <span style={{ fontFamily: "Open Sans" }}>{person.residance}</span>
            <br></br>
            <span className="float-end" style={{ fontFamily: "Open Sans" }}>
              {person.phone}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderDeadPerson = (person, idx) => {
    return (
      <div
        style={{ flexDirection: "column", marginBottom: "30px" }}
        key={idx}
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #EA6C8238",
            padding: "10px",
            borderRadius: "10px"
          }}
        >
          <div>
            <b>
              {person.alias} {person.surname}
            </b>
            <h6 style={{ fontFamily: "Open Sans" }}>
              {person.parent != null && (
                <>{person.gender == "Female" ? "Daughter Of" : "Son Of"} </>
              )}
              {person.parent == null ? "Root Member" : person.parentname}
            </h6>
            {person.parent != null && (
              <>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  Child Number: {person.born}
                </h6>
              </>
            )}
            
            <b>
              Died On: {person.deathdate}
            </b>
            <h6 style={{ fontFamily: "Open Sans" }}>
                  Burried At: {person.burriedat == null ? "Not mentioned" : person.burriedat}
            </h6>
            <button
              onClick={()=>markAlive(person.id)}
              style={{
                width: "150px",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
              className="float-right"
            >
              Mark As Still Alive
            </button>
          </div>
          <div style={{flexDirection: "column",
            display: "flex",
            justifyContent: "space-between", alignItems: "flex-end"}}>
            <span style={{ fontFamily: "Open Sans" }}>{person.residance}</span>
            <br></br>
            <span className="float-end" style={{ fontFamily: "Open Sans" }}>
              {person.phone}
            </span>
            <br/>
            <img
              alt="logo"
              style={{
                width: "130px",
                height: "130px",
                resizeMode: "stretch",
                border: "1px solid green",
                marginTop: "5px",
                borderRadius: "5px",
                alignSelf: "flex-end"
              }}
              src={
                person.img == null
                  ? `https://familytree.artblueinternational.com/family-tree/public/images/members/temp1.png`
                  : `https://familytree.artblueinternational.com/family-tree/public/images/members/${person.img}`
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const onSearchInput = (e) => {
    setSearchTerm(e.target.value);
  };

  const onSickSearchInput = (e) => {
    setSickSearchTerm(e.target.value);
  };

  return (
    <>
      <Modal
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            marginTop: "50px",
          },
          content: {
            backgroundColor: "#ffffff",
            color: "#EA6C82",
            left: "5%",
            right: "5%",
            height: "650px",
          },
          // content: {
          //   top: '50%',
          //   left: '50%',
          //   right: 'auto',
          //   bottom: 'auto',
          //   marginRight: '-50%',
          //   transform: 'translate(-50%, -50%)',
          // },
        }}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h2 style={{ fontFamily: "Open Sans", fontSize: 20 }}>Member Info</h2>

          <button
            style={{
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 40,
              fontFamily: "Open Sans",
              paddingInline: 14,
              fontSize: 14,
              color: "white",
              width: "110px",
            }}
            onClick={closeModal}
          >
            Close Modal
          </button>
        </div>

        <div className="row">
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              First Name(s)
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.firstName}
              onChange={(e) => {
                setMemberdata({ ...memberdata, firstName: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Surname
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.lastName}
              onChange={(e) => {
                setMemberdata({ ...memberdata, lastName: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Place of residence
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.place}
              onChange={(e) => {
                setMemberdata({ ...memberdata, place: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Gender
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.gender}
              onChange={(e) => {
                setMemberdata({ ...memberdata, gender: e.target.value });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Burrial Place
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.burrialplace}
              onChange={(e) => {
                setMemberdata({ ...memberdata, burrialplace: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Death Date
            </label>
            <br />
            <input
              type="date"
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.diedon}
              onChange={(e) => {
                setMemberdata({ ...memberdata, diedon: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
         
            
          </div>
          <div className="col-lg-3">
            <img
              alt="logo"
              style={{
                width: "100%",
                height: "220px",
                resizeMode: "stretch",
                border: "1px solid green",
                marginTop: "30px",
                borderRadius: "5px",
              }}
              src={
                memberdata.img == null
                  ? `https://familytree.artblueinternational.com/family-tree/public/images/members/temp1.png`
                  : `https://familytree.artblueinternational.com/family-tree/public/images/members/${memberdata.img}`
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3">
           
          </div>
          <div className="col-lg-3"></div>
          <div className="col-lg-3"></div>
          <div className="col-lg-3">
            <br />
            <button
              onClick={() => handleSubmit()}
              style={{
                width: "100%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
            >
              {isImageUploading === false && <>Save Death</>}
              {isImageUploading && (
                <>
                  <Squares />
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>Late Members</p>

        <span style={{ fontFamily: "Open Sans" }}>{familycode}</span>
      </div>
      {isShowDied == false && (
        <>
          <div
            style={{
              width: "100%",
              height: 60,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <input
              placeholder={"Search to add member as late. . ."}
              style={{
                width: "80%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={searchTerm}
              onChange={onSearchInput}
            />

            <button
              onClick={showDead}
              style={{
                width: "20%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                marginLeft: "5px",
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
              className="float-right"
            >
              View Late Members
            </button>
          </div>
          <p
            style={{
              fontFamily: "Open Sans",
              fontSize: "12",
              color: "#EA6C82",
            }}
          >
            To add member as late, click their name and update death details
            then press save death button
          </p>
          <FlatList
            list={contactlist}
            renderItem={renderPerson}
            renderWhenEmpty={() => (
              <div>
                <p style={{ color: "gray", fontFamily: "Open Sans" }}>
                  No items matching your search . . .
                </p>
              </div>
            )}
            sortBy={["level", { key: "level", descending: true }]}
            //   searchBy={["alias", "surname"]}
            //   searchTerm={searchTerm}
            search={{
              by: ["alias", "surname"],
              term: searchTerm,
              caseInsensitive: true,
            }}
            style={{ marginBottom: "300px" }}
          />
        </>
      )}
      {isShowDied && (
        <>
          <div
            style={{
              width: "100%",
              height: 60,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <input
              placeholder={"Search sick members. . ."}
              style={{
                width: "80%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={sickSearchTerm}
              onChange={onSickSearchInput}
            />

            <button
              onClick={showMembers}
              style={{
                width: "20%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                marginLeft: "5px",
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
              className="float-right"
            >
              View Family Members
            </button>
          </div>
          <p
            style={{
              fontFamily: "Open Sans",
              fontSize: "12",
              color: "#EA6C82",
            }}
          >
            Here is a list of all family members saved as sick. To remove sickness record click member and click mark as healed button
          </p>
          <FlatList
            list={deadlist}
            renderItem={renderDeadPerson}
            renderWhenEmpty={() => (
              <div>
                <p style={{ color: "gray", fontFamily: "Open Sans" }}>
                  No items matching your search . . .
                </p>
              </div>
            )}
            sortBy={["level", { key: "level", descending: true }]}
            //   searchBy={["alias", "surname"]}
            //   searchTerm={searchTerm}
            search={{
              by: ["alias", "surname"],
              term: sickSearchTerm,
              caseInsensitive: true,
            }}
            style={{ marginBottom: "700px" }}
          />
        </>
      )}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default AdminLate;
